import * as React from 'react';
import { useFormContext, Controller, ValidationRules } from 'react-hook-form';
import { Props as IComponentProps } from 'client/components/Form/Select';
import { get } from 'lodash';
import { ISelectorOption } from 'types/ISelectorOption';
import IconSelect from '../IconSelect';

interface IProps<T extends unknown>
  extends Omit<IComponentProps<T>, 'errors' | 'onChange' | 'value'> {
  name: string;
  selectClassName?: string;
  validate?: ValidationRules;
  initialValue?: ISelectorOption['value'] | ISelectorOption['value'][];
}

const FormIconSelect = <T extends unknown>({
  name,
  validate,
  initialValue,
  selectClassName,
  ...selectProps
}: IProps<T>) => {
  const { control, errors } = useFormContext();

  return (
    <Controller
      rules={validate}
      name={name}
      control={control}
      defaultValue={initialValue}
      render={({ onChange, value }) => (
        <IconSelect
          {...selectProps}
          id={name}
          value={value || initialValue}
          onChange={onChange}
          errors={get(errors, name)}
          selectClassName={selectClassName}
        />
      )}
    />
  );
};

export default FormIconSelect;
